import { useEffect, useState } from "react";
import { systemApi } from "../../services/systemApi";
import { config } from "../../services/runtimeConfig";
import { Card } from "../../components/common/Card";
import { Button } from "../../components/common/Button";
import { Toggle } from "../../components/common/Toggle";
import { GapNotice } from "../../components/common/GapNotice";

export function SystemManagementPage() {
  const [maintenance, setMaintenance] = useState({ enabled: false, message: "" });
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    systemApi.getMaintenanceMode().then((r) => setMaintenance(r)).catch(() => {}).finally(() => setLoaded(true));
  }, []);

  async function applyMaintenanceMode(enabled) {
    await systemApi.setMaintenanceMode(enabled, maintenance.message);
    setMaintenance((m) => ({ ...m, enabled }));
  }

  return (
    <div>
      <h1>System Management</h1>

      <Card title="Maintenance Mode" className="section-spacing">
        <p style={{ color: "var(--color-text-muted)" }}>
          Real toggle -- persists to dbo.AppConfig via the existing POST /management/maintenance-mode. When enabled, the
          consumer web/mobile apps should show a "We'll be back soon" page (that check needs to be added client-side
          if it isn't already reading this flag on load).
        </p>
        {loaded && (
          <>
            <Toggle label="Maintenance mode enabled" checked={maintenance.enabled} onChange={applyMaintenanceMode} />
            <textarea
              value={maintenance.message}
              onChange={(e) => setMaintenance((m) => ({ ...m, message: e.target.value }))}
              placeholder="We're performing scheduled maintenance and will be back shortly."
              rows={2}
              style={{ width: "100%", marginTop: "var(--space-3)" }}
            />
            <Button size="sm" onClick={() => systemApi.setMaintenanceMode(maintenance.enabled, maintenance.message)} style={{ marginTop: "var(--space-2)" }}>
              Save Message
            </Button>
          </>
        )}
      </Card>

      <Card title="System Announcements" className="section-spacing">
        <GapNotice>
          Would MERGE-upsert into dbo.AppConfig the same way maintenance_mode already does (see
          api/functions/admin.py's set_maintenance_mode) -- cheap to add given that pattern already exists, just not
          built yet.
        </GapNotice>
      </Card>

      <Card title="Scheduled Downtime" className="section-spacing">
        <GapNotice>No table tracks planned maintenance windows yet -- would need start/end timestamps plus a way to surface them to users ahead of time (banner, email, or both).</GapNotice>
      </Card>

      <Card title="Public Status Page" className="section-spacing">
        <p>Configured URL: <code>{config.statusPageUrl || "(not set)"}</code></p>
        <GapNotice>
          A real status.yourdomain.com is a separate, unauthenticated surface (not part of this admin SPA's auth-gated
          shell) fed by a small public read-only endpoint -- doesn't exist yet.
        </GapNotice>
      </Card>

      <Card title="API Replay / Debug Console">
        <GapNotice>
          Safely replaying a captured request against production needs careful design first (which endpoints are
          replay-safe/idempotent, sandboxed vs. real data) -- deliberately not stubbed with a fake "Replay" button
          here, since that would misrepresent something this risky as already working.
        </GapNotice>
      </Card>
    </div>
  );
}
